import type { FC } from "react";

import SelfEvaluationOptions from "./SelfEvaluationOptions";
import SelfEvaluationAnalysis from "./SelfEvaluationAnalysis";

import type { UserAssignmentDetailFragment } from "api/generated";

import type { TSolutionVariant } from "store/slices/exercise";

import { getTimeToLearn } from "utils/getTimeToLearn";

interface Props {
  sendDataToBe: boolean | null | undefined;
  selectedOptions: Array<{ points: number | null; status: TSolutionVariant | null }>;
  shownStep: "options" | string;
  userAssignment: UserAssignmentDetailFragment;
  handleEvaluationSelect: (index: number, option: number) => void;
  handleOptionsSubmit: () => boolean;
  handleNextClick: (() => void) | undefined;
}

const SelfEvaluationSolution: FC<Props> = ({
  sendDataToBe,
  selectedOptions,
  userAssignment,
  shownStep,
  handleEvaluationSelect,
  handleOptionsSubmit,
  handleNextClick,
}) => {
  if (userAssignment.assignment === undefined || userAssignment.assignment === null) return null;

  return (
    <>
      {shownStep === "options" ? (
        <SelfEvaluationOptions
          assignment={userAssignment.assignment}
          selectedOptions={selectedOptions}
          handleEvaluationSelect={handleEvaluationSelect}
          onConfirm={handleOptionsSubmit}
        />
      ) : (
        <SelfEvaluationAnalysis
          assignment={userAssignment}
          selectedOptions={selectedOptions}
          onNextClick={handleNextClick}
          timeToLearn={sendDataToBe === true ? getTimeToLearn(userAssignment.timeToLearn) : undefined}
        />
      )}
    </>
  );
};

export default SelfEvaluationSolution;
